import { BrowserRouter, Routes, Route } from 'react-router-dom';


// Import Bootstrap
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";

// Import Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import Date Range SCSS
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// Import SCSS
import "./assets/scss/main.scss";

// Import Pages
import HomePage from './pages/HomePage'
import OtcTrade from './pages/OtcTrade'
import TransactionHistory from './pages/TransactionHistory'
import DemoPage from './pages/DemoPage'
import ChooseWallet from './pages/ChooseWallet'
import PreRegistration from './pages/PreRegistration'
import AddWallet from './pages/AddWallet'
import LandingPage from './pages/LandingPage';
import XdcLandingPage from './pages/XdcLandingPage';
import CryptoLanding from './pages/CryptoLanding'
import CryptoLegal from './pages/CryptoLegal'

// Auth Pages
import LoginPage from './pages/auth/LoginPage'
import SignupPage from './pages/auth/SignupPage'
import ForgotPage from './pages/auth/ForgotPage'


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/home-page' element={<HomePage />}></Route>
        <Route path='/add-wallet' element={<AddWallet />}></Route>
        <Route path='/new-lending-page' element={<HomePage />}></Route>
        <Route path='/' element={<CryptoLanding />}></Route>
        <Route path='/crypto-legal' element={<CryptoLegal />}></Route>
        {/* <Route path='/' element={<ChooseWallet />}></Route> */}
        <Route path='/otc-trade' element={<OtcTrade />}></Route>
        <Route path='/transaction-history' element={<TransactionHistory />}></Route>
        <Route path='/login' element={<LoginPage />}></Route>
        <Route path='/signup' element={<SignupPage />}></Route>
        <Route path='/forgot' element={<ForgotPage />}></Route>
        <Route path='/pre-registration' element={<PreRegistration />}></Route>
        <Route path='/demo' element={<DemoPage />}></Route>
        <Route path='/xdc-landing' element={<XdcLandingPage />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
